export enum ReceiverType {
  YO = 'yo',
  OTRA = 'otra',
}
